// removed by extract-text-webpack-plugin
module.exports = {"Switch":"_1ffuY","Slider":"_2Even"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/SlidingSwitch/SlidingSwitch.scss
// module id = 713
// module chunks = 0